// Hook simples pra detectar mobile/tablet via media query.
// Usado em componentes que precisam de layouts radicalmente diferentes
// (ex.: header com hamburger vs tabs horizontais, drawer full-screen vs lateral).
//
// Para ajustes finos de spacing/font-size, prefira CSS media queries em index.css
// — não recarregam o componente, são mais performáticos.
import { useState, useEffect } from 'react';

const BREAKPOINT_MOBILE = 768;
const BREAKPOINT_TABLET = 1024;

export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState<boolean>(() =>
    typeof window !== 'undefined' && window.innerWidth < BREAKPOINT_MOBILE
  );
  useEffect(() => {
    function check() { setMobile(window.innerWidth < BREAKPOINT_MOBILE); }
    window.addEventListener('resize', check);
    check();
    return () => window.removeEventListener('resize', check);
  }, []);
  return mobile;
}

export function useIsTablet(): boolean {
  const [tablet, setTablet] = useState<boolean>(() =>
    typeof window !== 'undefined' && window.innerWidth < BREAKPOINT_TABLET
  );
  useEffect(() => {
    function check() { setTablet(window.innerWidth < BREAKPOINT_TABLET); }
    window.addEventListener('resize', check);
    check();
    return () => window.removeEventListener('resize', check);
  }, []);
  return tablet;
}

// Retorna ambos pra componentes que querem 3 layouts distintos
export function useViewport(): { mobile: boolean; tablet: boolean; desktop: boolean } {
  const mobile = useIsMobile();
  const tablet = useIsTablet();
  return { mobile, tablet: tablet && !mobile, desktop: !tablet };
}
